import React from "react";
import InspectedBy from "./InspectedBy";
import ApprovedBy from "./ApprovedBy";
import MyCheckbox from "@common-components/checkbox/CheckBox";
import "../cards/DarkCard.scss";

const QCP_ActionCards = ({ data }) => {
  let bgColor = "";

  switch (data?.status?.description?.toLowerCase()) {
    case "completed":
      bgColor = "bg-green-300";
      break;
    case "on hold":
      bgColor = "bg-gray-300 text-gray-700";
      break;
    case "in progress":
      bgColor = "bg-yellow-300 text-gray-700";
      break;
    case "new":
      bgColor = "bg-blue-300";
      break;
    default:
      bgColor = "bg-gray-200 text-gray-700";
  }

  console.log("dddd", data);
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-3 gap-2">
        <ul className="bg-gray-50 p-3 border rounded-md list-none dark-bg">
          <li className="flex items-center justify-between py-3">
            <p className="font-semibold mb-0">Date:</p>
            <p className="mb-0">{data?.createdDateUTC?.split("T")[0]}</p>
          </li>
          <li className="flex items-center justify-between py-3">
            <p className="font-semibold mb-0">Status:</p>
            <div
              className={`${bgColor} rounded h-6 px-2 flex items-center justify-center`}
            >
              <p className="mb-0">{data?.status?.description}</p>
            </div>
          </li>

          <li className="flex items-center justify-between py-3">
            <p className="font-semibold mb-0">Test Type:</p>
            <p className="mb-0">
              {data?.type === 1 ? "Fish Intake Control" : "Fillet Control 100"}
            </p>
          </li>

          <li className="flex items-center justify-between py-3">
            <p className="font-semibold mb-0">Performed by:</p>
            <p className="mb-0">{data?.inspectedBy}</p>
          </li>

          <li className="flex items-center justify-between py-3">
            <p className="font-semibold mb-0">Approved by:</p>
            <p className="mb-0">{data?.approvedBy}</p>
          </li>
          <li className="flex lg:flex-row flex-col items-start lg:items-center space-y-3 lg:space-y-0 justify-between py-3">
            <p className="font-semibold mb-0">Description:</p>
            <p className="mb-0">{data?.description}</p>
          </li>
        </ul>

        {data?.type === 1 ? (
          <ul className="bg-gray-50 p-3 border rounded-md list-none dark-bg">
            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Quality:</p>
              <p className="mb-0">{data?.quality ? "Ok" : "Not Ok"}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Weight:</p>
              <p className="mb-0">{data?.weight ? "Ok" : "Not Ok"}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Smell:</p>
              <p className="mb-0">{data?.smell ? "Ok" : "Not Ok"}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Quantity:</p>
              <p className="mb-0">{data?.quantity ? "Ok" : "Not Ok"}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Label Info:</p>
              <p className="mb-0">{data?.labelInfo ? "Ok" : "Not Ok"}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Packaging:</p>
              <p className="mb-0">{data?.packaging ? "Ok" : "Not Ok"}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Temperature:</p>
              <p className="mb-0">{data?.boxData?.temp} &#176;C</p>
            </li>
          </ul>
        ) : (
          <ul className="bg-gray-50 p-3 border rounded-md list-none dark-bg">
            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Bloodspot:</p>
              <p className="mb-0">{data?.bloodspot}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Cartilage:</p>
              <p className="mb-0">{data?.cartilage}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Deformed:</p>
              <p className="mb-0">{data?.deformed}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Gaping:</p>
              <p className="mb-0">{data?.gaping}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Melanin:</p>
              <p className="mb-0">{data?.melanin}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">Skin Wounds:</p>
              <p className="mb-0">{data?.skinWounds}</p>
            </li>

            <li className="flex items-center justify-between py-3">
              <p className="font-semibold mb-0">White Spots:</p>
              <p className="mb-0">{data?.whiteSpots}</p>
            </li>
          </ul>
        )}
      </div>
    </>
  );
};

export default QCP_ActionCards;
